import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const ActionToolbar = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;

  button {
    font-size: 14px;
    padding: 8px 16px;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    button {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const EatersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const EaterCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff8c42;
    box-shadow: 0 4px 12px rgba(10, 30, 61, 0.1);
    transform: translateY(-2px);
  }
`;

export const EaterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const EaterInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;

  div {
    margin: 0;
  }

  strong {
    color: #0a1e3d;
    font-weight: 600;
  }
`;

export const EaterActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const AddPressContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const AddPressContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const AddPressTitle = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const AddPressContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const TopFields = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const MiddleFields1 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const MiddleFields2 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const MiddleFields3 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const MiddleFields4 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const MiddleFields5 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const BottomFields = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const DiningReviewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ReviewCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff8c42;
    box-shadow: 0 4px 12px rgba(10, 30, 61, 0.1);
    transform: translateY(-2px);
  }
`;

export const ReviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const ReviewInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;

  div {
    margin: 0;
  }

  strong {
    color: #0a1e3d;
    font-weight: 600;
  }
`;

export const ReviewActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;

  button {
    font-size: 12px;
    padding: 6px 12px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  margin-top: 24px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const PaginationControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  button {
    padding: 8px 16px;
    font-size: 14px;
  }

  @media (max-width: 768px) {
    gap: 6px;

    button {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

export const PaginationInfo = styled.div`
  font-size: 14px;
  color: #0a1e3d;
  text-align: center;
  min-width: 150px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const PageSizeControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;
